
Render.add('.event-notify', function(){
    if (this.dataset.name) {
        Events.notify(this.dataset.name);
    }
});

Render.add('[data-eventsend]', function(){
    let goal = this.dataset.eventsend;
    if (goal) {
        if (typeof ym != "undefined" && typeof Consts.yandexCounter != "undefined") {
            ym(Consts.yandexCounter, 'reachGoal', goal);
            this.removeAttribute("data-eventsend");
            console.log(`Цель ${goal} отправлена`);
        }
    }
});

Events.attach("feedback-sended", function(){
    var goal = 'feedback-sended';
    if (typeof ym != "undefined" && typeof Consts.yandexCounter != "undefined") {
        Consts.yandexCounter.reachGoal(goal);
        console.log(`Цель ${goal} отправлена`);
    }
});

Events.attach("feedback-opened", function(){
    var goal = 'feedback-opened';
    if (typeof ym != "undefined" && typeof Consts.yandexCounter != "undefined") {
        Consts.yandexCounter.reachGoal(goal);
        console.log(`Цель ${goal} отправлена`);
    }
});


Events.attach("warranty-sended", function(){
    var goal = "warranty-sended";
    if (typeof ym != "undefined" && typeof Consts.yandexCounter != "undefined") {
        Consts.yandexCounter.reachGoal(goal);
        console.log(`Цель ${goal} отправлена`);
    }
});



